import styled from 'styled-components';
import { rgba } from 'polished';
import { colorLuminance } from 'utils/colors';

export const QualityNetworkStyled = styled.div`
&.s-quality-network{
    display: flex;
    flex-direction: row;
    background-color: ${({ theme }) => rgba(theme.black, 0.15)};
    border-top: 1px solid ${({ theme }) => rgba(theme.black, 0.25)};
    bottom: 0;
    opacity: 0;
    visibility: hidden;
    transform: translateY(100%);
    transition: transform 250ms ease;
    width: 100%;
    height: 0;
    &-line{
        display: flex;
        flex-direction: row;
        margin-bottom: 5px;
    }
    &-action{
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
    }
    &.active{
        padding: 10px 20px;
        height: auto;
        opacity: 1;
        visibility: visible;
        transform: translateY(0);
    }
    .icon{
        display: flex;
        margin-right: 10px;
        svg{
            color: ${({ theme }) => theme.white};
            width: 14px;
            height: 14px;
        }
    }
    .text{
        color: ${({ theme }) => theme.white};
        font-size: 12px;
        font-weight: bold;
    }
}`;

export const ContentChannelStyled = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    min-width: 0;
    flex-shrink: 0;
    overflow: auto;
    padding-bottom: 20px;
`;

export const Styled = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${props => colorLuminance(props.theme.mainColor1, 0.15)};
    padding: 0px 0px;
    position: relative;
    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) { max-width: 270px; }
    /* Small devices (portrait tablets and large phones, 600px and up) */
    @media only screen and (min-width: 600px) { max-width: 270px; }
    /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (min-width: 768px) { max-width: 270px; }
    /* Large devices (laptops/desktops, 992px and up) */
    @media only screen and (min-width: 1500px) { max-width: 300px; }
    /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media only screen and (min-width: 1600px) { min-width: 350px; max-width: 400px; }
    @media only screen and (min-width: 1700px) { min-width: 350px; max-width: 450px; }
    min-height: 0;
    min-width: 0;
    .placeholder{
        &-content{
            .subtext{
                align-items: flex-start;
            }
        }
    }
`;
